import { Header, Participants } from './components'
import styles from './styles.module.scss'
import { SidebarProps } from './types'

export const Sidebar = ({ conversation, onParticipantSelect }: SidebarProps) => {
  return (
    <div className={styles.sidebar}>
      <Header />
      <Participants
        conversation={conversation}
        onParticipantSelect={onParticipantSelect}
      />
    </div>
  )
}
